<mat-nav-list>
  <h3 matSubheader>Contratos para Renegociação</h3>

  <mat-divider></mat-divider>

  <mat-list-item
    *ngFor="let contrato of contratos"
    [ngClass]="{'itemSelected': contratoSelecionado  === contrato }"
  >
    <div
      fxLayout="row"
      fxLayout.xs="row"
      fxFlexFill
      fxLayoutAlign="left"
    >
      <div
        fxFlex="60%"
        class="contract-list"
      >
        <span matLine>Contrato</span>
        <span matLine> {{contrato.contrato}} </span>
      </div>

      <div
        fxFlex="40%"
        fxLayoutAlign="flex-end center"
      >
        <button
          *ngIf="contratoSelecionado === contrato"
          mat-raised-button
          color="secondary"
          (click)="selecionarContrato(contrato)"
        >Selecionado </button>

        <button
          *ngIf="contratoSelecionado !== contrato"
          mat-raised-button
          color="primary"
          (click)="selecionarContrato(contrato)"
        >Selecionar</button>

      </div>
    </div>
  </mat-list-item>
</mat-nav-list>
